// extracted by mini-css-extract-plugin
export default {"container":"BimWorkOrderActsKc2_container__lnubQ","innerBlock":"BimWorkOrderActsKc2_innerBlock__dZpe8","overlayLoader":"BimWorkOrderActsKc2_overlayLoader__81wuu"};